<template>
  <b-modal
    id="export-dialog"
    ref="modal"
    :title="$t('bookings.export')"
    size="sm"
    centered
  >
    <form ref="form" @submit="submit">
      <fields />
    </form>
  </b-modal>
</template>

<script>
import { FormMixin } from 'stylemix-base'
import BookingsApi from './Api'

export default {
  name: 'Export',

  mixins: [FormMixin],

  data: () => ({
    model: {},
    loaded: false,
  }),

  mounted() {
    const modal = this.$refs.modal

    modal.$on('shown', () => {
      if (this.loaded) {
        return
      }

      this.$uiBlocker(
        new BookingsApi().exportForm().then(result => {
          this.model = result.data
          this.setFields(result.fields)
        }),
        modal.$refs.content,
      )

      this.loaded = true
    })

    modal.$on('ok', event => {
      event.preventDefault()
      this.submit()
    })
  },

  methods: {
    submit() {
      this.$uiBlocker(
        new BookingsApi().exportUrl(this.model).then(result => {
          window.open(result.url)
          this.$refs.modal.hide()
        }),
        this.$refs.modal.$refs.content,
      )
    },
  },
}
</script>
